import { IconButton, Flex, useTheme } from '@vitvio/design-system';
import type { MergedIconProps } from '@vitvio/shared-components';
import { HomeIcon, KeyboardOpenIcon, TaskSquareIcon } from '@vitvio/shared-components';
import { NavLink } from 'react-router-dom';
import { HOME_ROUTE, OPERATING_ROOM_HOME, MISSION_CONTROL_HOME } from './routes';
import type { JSXElementConstructor } from 'react';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { MISSION_CONTROL_ONLY_FLAG } from '@vitvio/feature-flags';

export interface NavigationItem {
  ariaLabel: string;
  icon: JSXElementConstructor<MergedIconProps>;
  route: string;
}

const navItems: NavigationItem[] = [
  {
    ariaLabel: 'home-icon',
    icon: HomeIcon,
    route: HOME_ROUTE,
  },
  {
    ariaLabel: 'keyboard-open-icon',
    icon: KeyboardOpenIcon,
    route: MISSION_CONTROL_HOME,
  },
  {
    ariaLabel: 'task-square-icon',
    icon: TaskSquareIcon,
    route: OPERATING_ROOM_HOME,
  },
];

export function SidebarNavigation() {
  const { getFlag } = useKindeAuth();
  const { getColor, getSpacing } = useTheme();
  const missionControlOnly = getFlag && getFlag(MISSION_CONTROL_ONLY_FLAG, false, 'b').value;

  const filteredNavItems = navItems.filter(({ route }) => {
    if (route === HOME_ROUTE) {
      return true;
    }

    if (!missionControlOnly) {
      // ENG-767: this removes the other two buttons, as instructed in this ticket
      // this should normally be set to true
      // setting to false for now until we have functionality for user selecting their default home page
      return false;
    }
    return false;
  });

  return (
    <Flex as="nav" flexDir={'column'}>
      {filteredNavItems.map((item) => {
        return (
          <NavLink to={item.route} key={item.route}>
            {({ isActive }) => (
              <IconButton
                aria-label={item.ariaLabel}
                icon={<item.icon color={getColor(isActive ? 'fg.inverted' : 'fg')} />}
                _hover={{ bg: getColor('blue.300') }}
                background={isActive ? getColor('blue.500') : 'none'}
                fontSize={'xl'}
                py={getSpacing('5')}
                marginBottom={'10px'}
              />
            )}
          </NavLink>
        );
      })}
    </Flex>
  );
}
